import React from 'react';
import './HeaderNav.scss';
import { Link } from 'react-router-dom';
import mybcLogo from './MyBirthControl@2x.png'
import RainbowBar from '../RainbowBar.js'

export function HeaderNav(props) {
  return (
    <div id="HeaderNav">
      <RainbowBar />

      <div className="menuRow">
        <div className="title">
          <img src={mybcLogo} alt="My Birth Control"></img>
        </div>
        <div className="menu">
          <Link to="/" className={`homeLink ${props.position}`}>{props.lexicon.get('home')}</Link>
          <Link to="/providers" className={`providerLink ${props.position}`}>{props.lexicon.get('providers')}</Link>
          <Link to="/patients" className={`patientLink ${props.position}`}>{props.lexicon.get('patients')}</Link>
          <Link to="/about" className={`aboutLink ${props.position}`}>{props.lexicon.get('about')}</Link>
          <hr className={props.position} />
        </div>
      </div>
    </div>
  );
}

